import React, { HTMLProps, PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './IconButton.module.scss';

export const IconButton = ({
    children, onClick, title,
    className, small, active,
    disabled, ...rest
}: Props) => {

    const classes = classNames(styles.default, className, {
        [styles.small]: small,
        [styles.active]: active,
        'idt-active-toggleable': active,
        'idt-inactive': !active,
        'idt-button--disabled': disabled
    });

    return (
        <div className={classes} onClick={onClick} title={title} {...rest}>
            {children}
        </div>
    );
};

type StyleProps = {
    className?: string;
    active?: boolean;
    disabled?: boolean;
    small?: boolean;
};

type Props = PropsWithChildren<StyleProps & HTMLProps<HTMLDivElement>>;